import { useEffect, useRef, useState } from "react";

export default function LogoCarousel({ logos, speed = 30 }) {
  const containerRef = useRef(null);
  const trackRef = useRef(null);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const shouldAnimateRef = useRef(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: logos triggers re-measurement when list changes
  useEffect(() => {
    const check = () => {
      if (!(containerRef.current && trackRef.current)) return;
      const raw = trackRef.current.scrollWidth;
      const singleSetWidth = shouldAnimateRef.current ? raw / 2 : raw;
      const animate = singleSetWidth > containerRef.current.clientWidth;
      shouldAnimateRef.current = animate;
      setShouldAnimate(animate);
    };
    check();
    const ro = new ResizeObserver(check);
    ro.observe(trackRef.current);
    return () => ro.disconnect();
  }, [logos]);

  return (
    <div
      ref={containerRef}
      className="overflow-hidden w-full [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]"
    >
      <div
        ref={trackRef}
        className={`flex w-max ${shouldAnimate ? "animate-marquee hover:[animation-play-state:paused]" : "justify-center mx-auto"}`}
        style={shouldAnimate ? { animationDuration: `${speed}s` } : undefined}
      >
        {logos.map((logo, i) => (
          <img
            key={`a-${i}`}
            src={logo.src}
            alt={logo.alt}
            className="h-16 md:h-20 mx-8 object-contain opacity-90"
          />
        ))}
        {shouldAnimate &&
          logos.map((logo, i) => (
            <img
              key={`b-${i}`}
              src={logo.src}
              alt=""
              aria-hidden="true"
              className="h-16 md:h-20 mx-8 object-contain opacity-90"
            />
          ))}
      </div>
    </div>
  );
}
